import { join, reduce, map, assoc } from 'ramda'
import camelCase from 'camelcase'

const formatCategoryToParams = (category) => `$${camelCase(category)}: String!`

const getAllQueryParams = (categories) =>
  join(`, `, map(formatCategoryToParams, categories))

const getAllAliasedQueries = (categories) => {
  let aliasedQueries = ``

  categories.forEach((category, index) => {
    aliasedQueries += `${camelCase(category)}: resourcesByCategoryName(categoryName: $${camelCase(category)}) {
      edges {
        node {
          id
          slug
          title
          authorName
          type
          image {
            portrait {
              id
              name
              url
              altText
            }
            landscape {
              id
              name
              url
              altText
            }
          }
          resourceCategories {
            nodes {
              name
            }
          }
        }
      }
    }`

    if (index !== categories.length - 1) {
      aliasedQueries += `, `
    }
  })

  return aliasedQueries
}

export const createCombinedResourcesQuery = (categories) =>
  `query resourcesByCategoryName(${getAllQueryParams(categories)}) {${getAllAliasedQueries(categories)}}`

const addToObject = (obj, item) => assoc(camelCase(item), item, obj)

export const mapCategoriesToQueryVariables = reduce(addToObject, {})
